import {useBinaryState} from '@yandex-delivery/hooks'
import {useCallback} from 'react'

import {EventGoal, useFormUserEventHandler} from '../../../lib/metrika'

export function useBusinessOfferSlot() {
  const [isOpen, open, close] = useBinaryState()

  const handleReachGoal = useFormUserEventHandler()

  const handleOpen = useCallback(() => {
    handleReachGoal(EventGoal.B2BOfferClick)
    open()
  }, [handleReachGoal, open])

  return {
    isOpen,
    close,
    handleOpen,
  } as const
}
